export default __webpack_public_path__ + "shared/icons/avatar.png";